import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import Table from "../../../core/common/dataTable/index";
import ProfileTab from "../../../core/common/profiletab";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import useApi from "../../../core/customhook/useApi";
import Swal from "sweetalert2";

const PreviousWork = () => {
  const [callData, setCallData] = useState(1);
  const {
    data: onboardingstatus,
    loading: onboardingstatusLoading,
    error: onboardingstatusError,
  } = useApi("/api/onboarding/final-status", {
    method: "GET",
    autoCall: true,
  });

  const status = onboardingstatus?.data?.onb_status;
  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body;
  };
  const routes = all_routes;
  const [editData, setEditData] = useState<any>({});

  const ToggleText: React.FC<{ text: string }> = ({ text }) => {
    const [expanded, setExpanded] = useState(false);
    const isLong = text.length > 10;
    const displayText = expanded || !isLong ? text : text.slice(0, 10) + "...";

    return (
      <span className="text-secondary">
        {displayText}{" "}
        {isLong && (
          <button
            onClick={() => setExpanded(!expanded)}
            className="custom-btn link-btn"
          >
            {expanded ? "Less" : "More"}
          </button>
        )}
      </span>
    );
  };

  const columns1 = [
    {
      title: "S.No.",
      dataIndex: "sno",
    },
    {
      title: "Candidate Type",
      dataIndex: "candidate_type",
    },
    {
      title: "From Date",
      dataIndex: "from_date",
    },
    {
      title: "To Date",
      dataIndex: "to_date",
    },
    {
      title: "Employee Name",
      dataIndex: "employee_name",
    },
    {
      title: "Industry",
      dataIndex: "industry_name",
    },
    {
      title: "Joining Designation",
      dataIndex: "joining_designation",
    },
    {
      title: "Leaving Designation",
      dataIndex: "leaving_designation",
    },
    {
      title: "City",
      dataIndex: "city",
    },
    {
      title: "Country",
      dataIndex: "country",
    },
    {
      title: "CTC On Joining",
      dataIndex: "joined_annual_ctc",
      render: (text: string) => <span className="text-primary">{text}</span>,
    },
    {
      title: "CTC On Leaving",
      dataIndex: "left_annual_ctc",
      render: (text: string) => <span className="text-primary">{text}</span>,
    },
    {
      title: "Key Role/Skill",
      dataIndex: "job_role",
      render: (text: string) => <ToggleText text={text} />,
    },

    {
      title: "Reason For Separation",
      dataIndex: "sepration_reason",
      render: (text: string) => <span>{text}</span>,
    },
    {
      title: "Contract Type",
      dataIndex: "contract_type",
      render: (text: string) => <span>{text}</span>,
    },
    {
      title: "Employee Code",
      dataIndex: "prev_employee_code",
      render: (text: string) => <code>{text}</code>,
    },
    {
      title: "Agency Phone",
      dataIndex: "os_agency_phone_no",
      render: (text: string) => <span>{text}</span>,
    },
    {
      title: "Outsourcing Agency",
      dataIndex: "os_agency",
    },
    {
      title: "Agency Address",
      dataIndex: "os_agency_address",
      render: (text: string) => <small>{text}</small>,
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_: any, record: any) => {
        const canEdit =
          status === "In Progress" ||
          status === "Rejected" ||
          status === "Re Open" ||
          status === "Not Started";

        return (
          <i
            className={`ti ti-edit ${canEdit ? "text-primary" : "text-secondary"}`}
            style={{
              cursor: canEdit ? "pointer" : "not-allowed",
              opacity: canEdit ? 1 : 0.6,
            }}
            title={
              canEdit
                ? "Edit"
                : "Editing is disabled for this status"
            }
            onClick={() => {
              if (canEdit) {
                setEditData(record);
              }
            }}
            data-bs-toggle={canEdit ? "modal" : undefined}
            data-bs-target={canEdit ? "#editexampleModalLg" : undefined}
          />
        );
      },
    }

  ];

  const [data, setData] = useState({
    from_date: "",
    to_date: "",
    employee_name: "",
    industry_name: "",
    joining_designation: "",
    leaving_designation: "",
    city: "",
    country: "",
    joined_annual_ctc: "",
    left_annual_ctc: "",
    job_role: "",
    sepration_reason: "",
    contract_type: "",
    prev_employee_code: "",
    os_agency_phone_no: "",
    os_agency: "",
    os_agency_address: "",
    candidate_type: "Fresher"
  });

  const getInputData = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const getEditData = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setEditData({ ...editData, [name]: value });
  };

  const {
    data: prevWorkExpData,
    loading: prevWorkExpLoading,
    error: prevWorkExpError,
  } = useApi("/api/onboarding/view-work-experience", {
    method: "GET",
    autoCall: true,
    dependencies: [callData],
  });

  console.log(prevWorkExpData);

  const addSNo = prevWorkExpData?.data?.map((item: any, index: any) => {
    return {
      ...item,
      sno: index + 1,
    };
  });

  const {
    data: PrevWorkExp,
    loading,
    error,
    callApi: postPrevWorkExp,
  } = useApi("/api/onboarding/add-work-experience", {
    method: "POST",
    autoCall: false,
  });

  const postData = async (e: React.FormEvent<HTMLFormElement>) => {
    const payload = {
      ...data,
      from_date: data.from_date ? dayjs(data.from_date).format("DD/MM/YYYY") : null,
      to_date: data.to_date ? dayjs(data.to_date).format("DD/MM/YYYY") : null,
    };

    e.preventDefault();
    console.log(payload);
    try {
      const response = await postPrevWorkExp(payload);
      console.log(response);
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.message || "Data submitted successfully!",
          confirmButtonColor: "#3085d6",
        }).then(() => {
          document.getElementById("closeModalBtn")?.click();
        });
        setCallData(callData + 1);
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text:
          error?.response?.data?.message ||
          "Something went wrong while submitting the form.",
        confirmButtonColor: "#d33",
      });
    }
  };

  const {
    data: prevworkEditData,
    loading: prevworkEditLoading,
    error: prevworkEditError,
    callApi: editPreviousExpData,
  } = useApi("/api/onboarding/edit-work-experience", {
    method: "POST",
    autoCall: false,
  });

  const handleEdit = async (e: any) => {
    e.preventDefault();
    try {
      const payload = {
        ...editData,
        experience_id: editData.ID,
      };
      console.log(payload);
      const response = await editPreviousExpData(payload);
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.message || "Data submitted successfully!",
          confirmButtonColor: "#3085d6",
        }).then(() => {
          document.getElementById("editcloseModalBtn")?.click();
        });
        setCallData(callData + 1);
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text:
          error?.response?.data?.message ||
          "Something went wrong while submitting the form.",
        confirmButtonColor: "#d33",
      });
    }
  };
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1"> Previous Work Experience</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Administration</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Previous Work Experience
                  </li>
                </ol>
              </nav>
            </div>
            <div className="head-icons ms-2">
              <CollapseHeader />
            </div>
          </div>
          <div className="row">
            <div className="col-xl-3 theiaStickySidebar">
              <div
                className="stickybar"
                style={{ position: "sticky", top: "50px" }}
              >
                <ProfileTab />
              </div>
            </div>
            <div className="col-xl-9">
              <div className="card">
                <div className="card-body d-flex justify-content-between">
                  <div className="">
                    <h3>Previous Work Experience</h3>
                  </div>
                  {status === "In Progress" || status === "Rejected" || status === "Re Open" || status === "Not Started" ? <button
                    className="btn btn-primary custom_button"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModalLg"
                  >
                    {" "}
                    <i className="ti ti-circle-plus me-2" />
                    Add Experience
                  </button> : ""}

                </div>
                <div className="card">
                  <Table
                    dataSource={addSNo}
                    columns={columns1}
                    Selection={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModalLg"
        tabIndex={-1}
        aria-labelledby="exampleModalLgLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLgLabel">
                Previous Work Experience
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closeModalBtn"
              />
            </div>
            <div className="modal-body">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={postData}>
                    <div className="border-bottom mb-3">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Candidate Type<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                name="candidate_type"
                                className="form-select"
                                onChange={(e) => {
                                  getInputData(e);
                                  setData((prev) => ({ ...prev, candidate_type: e.target.value }));
                                }}
                                required
                              >
                                <option value="" disabled selected>
                                  Select Candidate Type
                                </option>
                                <option value="Fresher">Fresher</option>
                                <option value="Experienced">Experienced</option>
                              </select>

                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                From Date
                              </label>
                            </div>
                            <div className="col-md-8">
                              <div className="input-icon-end position-relative">
                                <DatePicker
                                  className="form-control datetimepicker"
                                  format="DD-MM-YYYY"
                                  getPopupContainer={getModalContainer}
                                  placeholder="DD-MM-YYYY"
                                  name="from_date"
                                  value={
                                    data.from_date
                                      ? dayjs(data.from_date, "YYYY-MM-DD")
                                      : null
                                  }
                                  onChange={(date) =>
                                    setData((prev: any) => ({
                                      ...prev,
                                      from_date: date ? date.format("YYYY-MM-DD") : null
                                    }))
                                  }
                                  disabledDate={(current) =>
                                    current &&
                                    current.isAfter(dayjs().startOf("day"))
                                  }
                                  disabled={data.candidate_type === "Fresher"}
                                />
                                <span className="input-icon-addon">
                                  <i className="ti ti-calendar text-gray-7" />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                To Date
                              </label>
                            </div>
                            <div className="col-md-8">
                              <div className="input-icon-end position-relative">
                                <DatePicker
                                  className="form-control datetimepicker"
                                  format="DD-MM-YYYY"
                                  getPopupContainer={getModalContainer}
                                  placeholder="DD-MM-YYYY"
                                  name="to_date" // Field name
                                  value={
                                    data.to_date
                                      ? dayjs(data.to_date, "YYYY-MM-DD")
                                      : null
                                  }
                                  onChange={(date) =>
                                    setData((prev: any) => ({
                                      ...prev,
                                      to_date: date ? date.format("YYYY-MM-DD") : null
                                    }))
                                  }
                                  disabledDate={(current) =>
                                    current &&
                                    current.isAfter(dayjs().startOf("day"))
                                  }
                                  disabled={data.candidate_type === "Fresher"}
                                />
                                <span className="input-icon-addon">
                                  <i className="ti ti-calendar text-gray-7" />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Name of Employer

                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter employer name"
                                name="employee_name"
                                onChange={getInputData}
                                disabled={data.candidate_type === "Fresher"}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Industry
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter industry name"
                                name="industry_name"
                                onChange={getInputData}
                                disabled={data.candidate_type === "Fresher"}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Designation on Joining*

                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                name="joining_designation"
                                onChange={getInputData}
                                disabled={data.candidate_type === "Fresher"}
                                id=""
                                placeholder="Enter joining designation"
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Designation on Leaving

                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                name="leaving_designation"
                                onChange={getInputData}
                                disabled={data.candidate_type === "Fresher"}
                                className="form-control"
                                placeholder="Enter leaving designation"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                City
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter city name"
                                name="city"
                                onChange={getInputData}
                                disabled={data.candidate_type === "Fresher"}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Country
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter country name"
                                name="country"
                                onChange={getInputData}
                                disabled={data.candidate_type === "Fresher"}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Annual CTC when you joined
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Enter CTC at joining"
                                name="joined_annual_ctc"
                                onChange={getInputData}
                                disabled={data.candidate_type === "Fresher"}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Annual CTC when you left
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Enter CTC at leaving"
                                name="left_annual_ctc"
                                onChange={getInputData}
                                disabled={data.candidate_type === "Fresher"}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Key Role/ Skill Set
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter key role or skill set"
                                name="job_role"
                                onChange={getInputData}
                                disabled={data.candidate_type === "Fresher"}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Reason for Separation
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter reason for separation"
                                name="sepration_reason"
                                onChange={getInputData}
                                disabled={data.candidate_type === "Fresher"}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Contract Type
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                name="contract_type"
                                id=""
                                className="form-select"
                                onChange={getInputData}
                                disabled={data.candidate_type === "Fresher"}
                              >
                                <option value="" selected disabled>Select Contract Type</option>
                                <option value="Permanent">Permanent</option>
                                <option value="Contractual">Contractual</option>
                                <option value="Part Time">Part Time</option>
                                <option value="Temporary">Temporary</option>
                                <option value="Consultant">Consultant</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Employee code
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter employee code"
                                name="prev_employee_code"
                                onChange={getInputData}
                                disabled={data.candidate_type === "Fresher"}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Outsourcing agency's Phone number
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="tel"
                                className="form-control"
                                placeholder="Enter phone number"
                                name="os_agency_phone_no"
                                onChange={getInputData}
                                disabled={data.candidate_type === "Fresher"}
                                maxLength={10}
                                pattern="\d*"
                                inputMode="numeric"
                                onKeyPress={(e) => {
                                  if (!/^\d$/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Outsourcing agency
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter agency name"
                                name="os_agency"
                                onChange={getInputData}
                                disabled={data.candidate_type === "Fresher"}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="row align-items-start mb-3">
                            <div className="col-xxl-2 col-md-3">
                              <label className="form-label mb-md-0">
                                Outsourcing agency's address
                              </label>
                            </div>
                            <div className="col-xxl-10 col-md-9">
                              <textarea
                                className="form-control"
                                rows={2}
                                placeholder="Enter agency address"
                                name="os_agency_address"
                                onChange={getInputData}
                                disabled={data.candidate_type === "Fresher"}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Buttons */}
                    <div className="d-flex align-items-center justify-content-end">
                      <button
                        type="button"
                        className="btn btn-outline-light border me-3"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary custom_button">
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="editexampleModalLg"
        tabIndex={-1}
        aria-labelledby="exampleModalLgLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLgLabel">
                Edit Previous Work Experience
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="editcloseModalBtn"
              />
            </div>
            <div className="modal-body">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleEdit}>
                    <div className="border-bottom mb-3">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Candidate Type<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                name="candidate_type"
                                className="form-select"
                                value={editData.candidate_type}
                                onChange={getEditData}
                              >
                                <option value="" disabled selected>
                                  Select Candidate Type
                                </option>
                                <option value="Fresher">Fresher</option>
                                <option value="Experienced">Experienced</option>
                              </select>

                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                From Date
                              </label>
                            </div>
                            <div className="col-md-8">
                              <div className="input-icon-end position-relative">
                                <DatePicker
                                  className="form-control datetimepicker"
                                  format="DD-MM-YYYY"
                                  placeholder="DD-MM-YYYY"
                                  name="from_date"
                                  value={
                                    editData.from_date
                                      ? dayjs(editData.from_date, "DD/MM/YYYY")
                                      : null
                                  }
                                  onChange={(date) =>
                                    setEditData((prev: any) => ({
                                      ...prev,
                                      from_date: date ? date.format("DD/MM/YYYY") : null,
                                    }))
                                  }
                                  disabled={editData.candidate_type === "Fresher"}
                                />

                                <span className="input-icon-addon">
                                  <i className="ti ti-calendar text-gray-7" />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                To Date
                              </label>
                            </div>
                            <div className="col-md-8">
                              <div className="input-icon-end position-relative">
                                <DatePicker
                                  className="form-control datetimepicker"
                                  format="DD-MM-YYYY"
                                  placeholder="DD-MM-YYYY"
                                  name="to_date"
                                  value={
                                    editData.to_date
                                      ? dayjs(editData.to_date, "DD/MM/YYYY")
                                      : null
                                  }
                                  onChange={(date) =>
                                    setEditData((prev: any) => ({
                                      ...prev,
                                      to_date: date ? date.format("DD/MM/YYYY") : null,
                                    }))
                                  }
                                  disabled={editData.candidate_type === "Fresher"}
                                />

                                <span className="input-icon-addon">
                                  <i className="ti ti-calendar text-gray-7" />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Name of Employer

                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter employer name"
                                name="employee_name"
                                value={editData.employee_name}
                                onChange={getEditData}
                                disabled={editData.candidate_type === "Fresher"}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Industry
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter industry name"
                                name="industry_name"
                                value={editData.industry_name}
                                onChange={getEditData}
                                disabled={editData.candidate_type === "Fresher"}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Designation on Joining*

                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                name="joining_designation"
                                value={editData.joining_designation}
                                onChange={getEditData}
                                disabled={editData.candidate_type === "Fresher"}
                                placeholder="Enter joining designation"
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Designation on Leaving

                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                name="leaving_designation"
                                value={editData.leaving_designation}
                                onChange={getEditData}
                                disabled={editData.candidate_type === "Fresher"}
                                className="form-control"
                                placeholder="Enter leaving designation"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                City
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter city name"
                                name="city"
                                value={editData.city}
                                onChange={getEditData}
                                disabled={editData.candidate_type === "Fresher"}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Country
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter country name"
                                name="country"
                                value={editData.country}
                                onChange={getEditData}
                                disabled={editData.candidate_type === "Fresher"}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Annual CTC when you joined

                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Enter CTC at joining"
                                name="joined_annual_ctc"
                                value={editData.joined_annual_ctc}
                                onChange={getEditData}
                                disabled={editData.candidate_type === "Fresher"}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Annual CTC when you left
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Enter CTC at leaving"
                                name="left_annual_ctc"
                                value={editData.left_annual_ctc}
                                onChange={getEditData}
                                disabled={editData.candidate_type === "Fresher"}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Key Role/ Skill Set
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter key role or skill set"
                                name="job_role"
                                value={editData.job_role}
                                onChange={getEditData}
                                disabled={editData.candidate_type === "Fresher"}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Reason for Separation
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter reason for separation"
                                name="sepration_reason"
                                value={editData.sepration_reason}
                                onChange={getEditData}
                                disabled={editData.candidate_type === "Fresher"}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Contract Type
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                name="contract_type"
                                className="form-select"
                                value={editData.contract_type}
                                onChange={getEditData}
                                disabled={editData.candidate_type === "Fresher"}
                              >
                                <option value="" selected disabled>Select Contract Type</option>
                                <option value="Permanent">Permanent</option>
                                <option value="Contractual">Contractual</option>
                                <option value="Part Time">Part Time</option>
                                <option value="Temporary">Temporary</option>
                                <option value="Consultant">Consultant</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Employee code
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter employee code"
                                name="prev_employee_code"
                                value={editData.prev_employee_code}
                                onChange={getEditData}
                                disabled={editData.candidate_type === "Fresher"}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Outsourcing agency's Phone number
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="tel"
                                className="form-control"
                                placeholder="Enter phone number"
                                name="os_agency_phone_no"
                                value={editData.os_agency_phone_no}
                                onChange={getEditData}
                                disabled={editData.candidate_type === "Fresher"}
                                maxLength={10}
                                pattern="\d*"
                                inputMode="numeric"
                                onKeyPress={(e) => {
                                  if (!/^\d$/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Outsourcing agency
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter agency name"
                                name="os_agency"
                                value={editData.os_agency}
                                onChange={getEditData}
                                disabled={editData.candidate_type === "Fresher"}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="row align-items-start mb-3">
                            <div className="col-xxl-2 col-md-3">
                              <label className="form-label mb-md-0">
                                Outsourcing agency's address
                              </label>
                            </div>
                            <div className="col-xxl-10 col-md-9">
                              <textarea
                                className="form-control"
                                rows={2}
                                placeholder="Enter agency address"
                                name="os_agency_address"
                                value={editData.os_agency_address}
                                onChange={getEditData}
                                disabled={editData.candidate_type === "Fresher"}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Buttons */}
                    <div className="d-flex align-items-center justify-content-end">
                      <button
                        type="button"
                        className="btn btn-outline-light border me-3"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PreviousWork;
